import { formatDateTime } from "../../../users/adminUserFormatters";
import { formatFrameAge } from "../../../../../../utils/radarHealthAdminUtils";

const WeatherSiataObservabilityPanel = ({ siataSummary, fallbacks }) => {
  if (!siataSummary) {
    return (
      <div className="weather-observability-siata panel-card">
        <h3 className="admin-section-title">SIATA Santa Elena observability</h3>
        <p className="muted">No SIATA metrics snapshots yet. Run metrics collection.</p>
      </div>
    );
  }

  const georef = siataSummary.metadata?.georef || {};
  const siataToIdeam = fallbacks?.siataToIdeamCount ?? 0;
  const toRainViewer = fallbacks?.siataOrIdeamToRainViewerCount ?? 0;
  const valleyPreferredSelections =
    fallbacks?.renderedSourceDistribution?.siata_santa_elena ?? 0;

  return (
    <div className="weather-observability-siata panel-card">
      <h3 className="admin-section-title">SIATA Santa Elena observability</h3>
      <div className="weather-observability-siata__grid">
        <div>
          <span className="weather-radar-calibration__label">Latest frame age</span>
          <strong>{formatFrameAge(siataSummary.averageFrameAgeMinutes)}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Renderable frames</span>
          <strong>{siataSummary.renderableFrameCount ?? "—"}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Cache size</span>
          <strong>
            {siataSummary.cacheSizeBytes
              ? `${Math.round(siataSummary.cacheSizeBytes / (1024 * 1024))} MB`
              : "—"}
          </strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Uptime (range)</span>
          <strong>
            {siataSummary.uptimePercent != null ? `${siataSummary.uptimePercent}%` : "—"}
          </strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Georef confidence</span>
          <strong>{georef.confidence || "—"}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Calibration version</span>
          <strong>{georef.calibrationVersion || "—"}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Valley Preferred renders</span>
          <strong>{valleyPreferredSelections}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Fallback → IDEAM</span>
          <strong>{siataToIdeam}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Fallback → RainViewer</span>
          <strong>{toRainViewer}</strong>
        </div>
        <div>
          <span className="weather-radar-calibration__label">Latest snapshot</span>
          <span>{formatDateTime(siataSummary.latestSnapshotAt)}</span>
        </div>
      </div>
      <p className="muted">
        Sync failures in range: {siataSummary.syncFailureCount ?? 0} · Stale incidents:{" "}
        {siataSummary.staleCount ?? 0} · Unavailable incidents: {siataSummary.unavailableCount ?? 0}
      </p>
    </div>
  );
};

export default WeatherSiataObservabilityPanel;
